// Single source of truth for "which branch is this operator working in".
//
// The branch switcher writes auth.activeBranchId and http.js mirrors it into the
// X-Branch-Id header. psDefaultBranch is only a fallback: on a multi-branch tenant it
// is the operator's home branch, not the one they switched to.
//
// Use this for gate pickers (check-in form, code scanner, personal settings) and for the
// member-entry hub subscription. Do NOT use it for a filter dropdown whose rows are
// already scoped by the X-Branch-Id header alone -- such a dropdown must mirror the row
// query exactly, and the header covers both the scoped and the all-branches case.
export const resolveBranchId = (authState) => {
  if (!authState) return undefined;
  if (authState.activeBranchId) return authState.activeBranchId;
  const { userData } = authState;
  return (userData && userData.psDefaultBranch) || undefined;
};

// The branches a user may act in, out of everything the server returned.
//
// The server filters too, but three screens were each deciding this for themselves and the report
// filter was not deciding at all, which is how a scoped user got offered branches they cannot see.
// One rule, used by every branch picker.
export const accessibleBranches = (authState, branches) => {
  const all = branches || [];
  const access = (authState && authState.branchAccess) || {};

  if (access.canAccessAllBranches) return all;

  const ids = access.accessibleBranchIds || [];
  // Nobody has scoped this user, so nothing is out of bounds. Matches RoleManager, which reads no
  // rows as access to every branch rather than to none.
  if (!ids.length) return all;

  return all.filter((b) => ids.some((id) => String(id) === String(b.id)));
};
